import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

import type { FC } from 'react';

interface DateCellProps {
  date?: string | Date;
}

const DateCell: FC<DateCellProps> = ({ date }) => {
  return (
    <div className={s.date}>
      {DateFormatter({
        date,
        format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
      })}
    </div>
  );
};
export default DateCell;
